import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-webhook-delivery-failed-template',
  styleUrls: ['../../global-styles.less', './webhook-delivery-failed.component.less'],
  templateUrl: './webhook-delivery-failed.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class WebhookDeliveryFailedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<WebhookDeliveryFailedTemplateData>;
}

export type WebhookDeliveryFailedTemplateData = {
  title: string;
  description: string;
  technical_details: string;
  action_needed: string;
  go_to_settings_text: string;
  go_to_settings_link: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const WebhookDeliveryFailedTemplateMocks: WebhookDeliveryFailedTemplateData[] = [
  {
    title: 'Failed webhook delivery',
    description: 'There was an error with one of your webhooks.',
    technical_details: 'Place for technical details',
    action_needed:
      'Action on your servers is most likely needed. You can also go to your settings page to see all enabled webhooks.',
    go_to_settings_text: 'Go to webhook settings',
    go_to_settings_link: 'https://app.s.recruitee.com/#/settings/webhooks',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
